import Api from 'Api/Api';

class VideoTemplate extends Api {
  constructor(carePlanTemplateId, id = null) {
    super();

    this.id = id;
    this.carePlanTemplateId = carePlanTemplateId;
  }

  create(videoTemplateData) {
    return super.create(videoTemplateData);
  }

  update(videoTemplateData) {
    return super.update(videoTemplateData);
  }

  destroy() {
    return super.destroy({});
  }

  get url() {
    return `/care_plan_templates/${this.carePlanTemplateId}/video_templates`;
  }
}

export default VideoTemplate;
